import {
  Box,
  Button,
  Collapse,
  ExpandMoreRoundedIcon,
  FilterListOutlinedIcon,
  Flex,
  Rotate,
  SearchInput,
} from '@shared/components';
import { useDisclosure } from '@shared/hooks';

import { useAdminProctorRequestListSearchParams } from '../../hooks';
import { AdminProctorFilterSection } from '../admin-proctor-filter-section';

export default function AdminProctorSearchFilterSection() {
  const [, { changeSearch }] = useAdminProctorRequestListSearchParams();
  const [isExpand, { toggle }] = useDisclosure(false);

  const handleSearchInputChange = (value: string) => {
    changeSearch(value);
  };

  return (
    <>
      <Flex sx={{ justifyContent: 'space-between' }}>
        <Box sx={{ width: 300 }}>
          <SearchInput placeholder='ค้นหาชื่อผู้คุมสอบ...' onChange={handleSearchInputChange} />
        </Box>
        <Button
          variant='outlined'
          color='secondary'
          size='large'
          startIcon={<FilterListOutlinedIcon />}
          endIcon={
            <Rotate in={isExpand}>
              <ExpandMoreRoundedIcon />
            </Rotate>
          }
          onClick={toggle}
        >
          Filter
        </Button>
      </Flex>
      <Collapse in={isExpand} unmountOnExit>
        <AdminProctorFilterSection />
      </Collapse>
    </>
  );
}
